import React from 'react';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import { focusTrap, Link } from '@resy/ui-kitchen';
import { FAQS_URL } from '../../AmexGDA/constants';
import { updateLinksWithOriginB2B } from '../../AmexMarketingUtils/AmexUtils';
import '../../AmexGDA/AmexGDAHeader/AmexGDAHeader.scss';
import SideDrawer from '../../AmexGDA/AmexGDAHeader/SideDrawer';
import MobileMenu from '../../AmexGDA/AmexGDAHeader/MobileMenu';
import CustomImage from '../../AmexGDA/CustomImage';

class AmexGDADirHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sideDrawerOpen: false,
    };
  }

  componentWillUnmount() {
    focusTrap.focusRemove();
  }

  drawerToggleClickHandler = () => {
    this.setState((prevState) => ({
      sideDrawerOpen: !prevState.sideDrawerOpen,
    }));
  }

  render() {
    const { sideDrawerOpen } = this.state;
    const { hideEvents } = this.props;
    const {
      menuItems = [], mobileMenuContent, headerExplore, headerTextImg, baseRequestUrl, amexFooterImg, printContent, isGdaMember, isGdaEligible,
      isUSLocation, Analytics, hideFAQs, hasOriginB2B,
    } = this.props;

    const updatedMenuItems = menuItems.map((item) => {
      if (item.text === 'Partner Overview') {
        return { ...item, hide: !hasOriginB2B };
      }
      return item;
    });

    let menuItemsToDisplay = updatedMenuItems?.filter((item) => {
      if (!item.hide) return item;
      return null;
    });

    if (hideEvents) {
      menuItemsToDisplay = menuItemsToDisplay?.filter((item) => {
        if (item.link !== './global-dining-access#EventsExperiences') {
          return item;
        }
        return null;
      });
    }

    if (isGdaMember || isGdaEligible) {
      menuItemsToDisplay = menuItemsToDisplay?.filter((item) => {
        if (item.onlyGdaMember === -1 || item.onlyGdaMember === 1) {
          return item;
        }
        return null;
      });
    } else {
      menuItemsToDisplay = menuItemsToDisplay?.filter((item) => {
        if (item.onlyGdaMember === -1 || item.onlyGdaMember === 0) {
          return item;
        }
        return null;
      });
    }

    if (isUSLocation) {
      menuItemsToDisplay = menuItemsToDisplay?.filter((item) => {
        if (item.onlyUsCountry === -1 || item.onlyUsCountry === 1) {
          return item;
        }
        return null;
      });
    } else {
      menuItemsToDisplay = menuItemsToDisplay?.filter((item) => {
        if (item.onlyUsCountry === -1 || item.onlyUsCountry === 0) {
          return item;
        }
        return null;
      });
    }

    if (hideFAQs) {
      menuItemsToDisplay = filter(menuItemsToDisplay, ((item) => {
        if (item.link !== FAQS_URL) return item;
        return null;
      }));
    }

    // sort menu items based on ID
    menuItemsToDisplay = menuItemsToDisplay?.filter((x) => (x !== null));
    const menuItemsOrdered = menuItemsToDisplay?.sort(
      (item1, item2) => {
        if (item1.id < item2.id) return -1;
        if (item1.id > item2.id) return 1;
        return 0;
      }
    );

    return (
      <>
        <section>
          <header className="GDA__MobileMenu">
            <nav aria-label="Primary navigation mobile">
              <MobileMenu
                drawerClickHandler={this.drawerToggleClickHandler}
                show={sideDrawerOpen}
                headerTextImg={headerTextImg}
                baseRequestUrl={baseRequestUrl}
              />
              <SideDrawer
                onAfterClose={focusTrap.focusPage}
                onAfterOpen={focusTrap.focusModal}
                menuItems={menuItemsOrdered}
                mobileMenuContent={mobileMenuContent}
                show={sideDrawerOpen}
                drawerClickHandler={this.drawerToggleClickHandler}
                headerTextImg={headerTextImg}
                baseRequestUrl={baseRequestUrl}
                amexFooterImg={amexFooterImg}
                printContent={printContent}
                Analytics={Analytics}
                hasOriginB2B={hasOriginB2B}
              />
            </nav>
          </header>
        </section>
        <section className="ResyAmexGDAHeader">
          <div className="ResyAmexGDAHeader__container">
            <div className="ResyAmexGDAHeader__topbar">
              <Link className="GDA__Header" href="/">
                {printContent(headerExplore, 'headerExplore')}
              </Link>
            </div>
            <div className="ResyAmexGDAHeader__logo-desktop-wrap">
              <Link
                className="GDA__Header accessible-focus"
                href={updateLinksWithOriginB2B('/global-dining-access', hasOriginB2B)}
                aria-label="Resy Global Dining Access"
              >
                <CustomImage key={headerTextImg} imageName={headerTextImg} baseRequestUrl={baseRequestUrl} fileType="svg" />
              </Link>
            </div>
          </div>
        </section>
      </>
    );
  }
}

AmexGDADirHeader.propTypes = {
  headerExplore: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  mobileMenuContent: PropTypes.objectOf(PropTypes.string).isRequired,
  headerTextImg: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  amexFooterImg: PropTypes.string.isRequired,
  printContent: PropTypes.func.isRequired,
  isGdaMember: PropTypes.bool.isRequired,
  isGdaEligible: PropTypes.bool.isRequired,
  isUSLocation: PropTypes.bool.isRequired,
  hasOriginB2B: PropTypes.bool.isRequired,
  hideFAQs: PropTypes.bool,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  hideEvents: PropTypes.bool.isRequired,
};
AmexGDADirHeader.defaultProps = {
  hideFAQs: false,
};

export default AmexGDADirHeader;
